import en from './en';

type Translation = {
  [key in keyof typeof en]: string;
};

type AssignmentTranslations = {
  [lang: string]: Translation;
};

export const assignmentTranslations: AssignmentTranslations = {
  en,
};
